const VIEWED_PRODUCTS_KEY = 'mara-paris-viewed-products'
const VIEWED_PRODUCTS_LIMIT = 20

function readViewedProducts() {
  try {
    const parsed = JSON.parse(localStorage.getItem(VIEWED_PRODUCTS_KEY) || '[]')
    if (!Array.isArray(parsed)) return []
    return parsed.map((id) => String(id)).filter(Boolean)
  } catch (error) {
    return []
  }
}

function rememberViewedProduct(productId) {
  if (!productId) return
  const id = String(productId)
  const next = [id, ...readViewedProducts().filter((item) => item !== id)].slice(0, VIEWED_PRODUCTS_LIMIT)
  try {
    localStorage.setItem(VIEWED_PRODUCTS_KEY, JSON.stringify(next))
  } catch (error) {}
}

rememberViewedProduct(document.querySelector('product-info[data-product-id]')?.dataset.productId)

class CartDrawer extends HTMLElement {
  constructor() {
    super()
    this.upsellRequestId = 0
    this.upsellSwiperToken = 0
    this.container =  this.querySelector('#cart-drawer-container')
    this.cartButton = document.querySelector('#cart-button')

    this.container.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open()
      }
    })
    this.cartButton.addEventListener('click', () => this.open())
    document.body.addEventListener('keydown', (evt) => evt.code === 'Escape' && this.close())

    this.init()
  }

  init() {
    this.overlay = this.querySelector('#cart-drawer-overlay')
    this.contents = this.querySelector('#cart-drawer-contents')
    this.scrollContainer = this.querySelector('#cart-drawer-scroll-container')
    // document.querySelector('#cart-close-button').addEventListener('click', () => this.close())

    this.overlay.addEventListener('click', () => this.close())
  }

  open() {
    document.querySelector('predictive-search')?.closeSearch({ restoreFocus: false })

    // Body
    document.documentElement.classList.add('overflow-hidden')
    document.body.classList.add('drawer-cart-is-open')

    // Container
    this.container.classList.remove('invisible')
    this.container.classList.remove('pointer-events-none')

    // Overlay
    this.overlay.classList.add('opacity-100')
    this.overlay.classList.remove('opacity-0')
    this.overlay.classList.remove('delay-200')

    // Contents
    this.scrollContainer.scrollTop = 0
    this.contents.classList.add('right-0')
    this.contents.classList.remove('-right-96')

    this.loadUpsell()
  }

  fetchRecommendations(slot, productId, intent) {
    const url = new URL(slot.dataset.recommendationsUrl, window.location.origin)
    url.searchParams.set('section_id', 'cart-upsell')
    url.searchParams.set('product_id', String(productId))
    url.searchParams.set('limit', '10')
    url.searchParams.set('intent', intent)
    return fetch(url.toString()).then((response) => response.text())
  }

  collectUpsellCards(html, seen, cards) {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    doc.querySelectorAll('[data-upsell-product-id]').forEach((card) => {
      const id = card.dataset.upsellProductId
      if (!id || seen.has(id) || cards.length >= 7) return
      seen.add(id)
      cards.push(card.outerHTML)
    })
  }

  renderUpsell(slot, cards) {
    const swiperToken = ++this.upsellSwiperToken
    if (this.upsellSwiper) {
      this.upsellSwiper.destroy(true, true)
      this.upsellSwiper = null
    }

    const wrapper = slot.querySelector('.swiper-wrapper')
    if (!cards.length || !wrapper) {
      if (wrapper) wrapper.replaceChildren()
      slot.classList.add('hidden')
      return
    }

    wrapper.innerHTML = cards.map((card) => `<div class="swiper-slide">${card}</div>`).join('')
    slot.classList.remove('hidden')

    const swiperEl = slot.querySelector('.swiper')
    if (!swiperEl || typeof Swiper !== 'function') return

    requestAnimationFrame(() => {
      if (swiperToken !== this.upsellSwiperToken || !swiperEl.isConnected) return
      this.upsellSwiper = new Swiper(swiperEl, {
        slidesPerView: 2.15,
        spaceBetween: 12,
        loop: cards.length > 2,
        watchOverflow: true,
      })

      const prev = slot.querySelector('.upsell-prev')
      const next = slot.querySelector('.upsell-next')
      if (prev) prev.onclick = () => this.upsellSwiper?.slidePrev()
      if (next) next.onclick = () => this.upsellSwiper?.slideNext()
    })
  }

  loadUpsell() {
    // TEMP: cart upsell disabled — remove this return to re-enable
    return

    const slot = this.querySelector('#cart-drawer-upsell')
    if (!slot?.dataset.recommendationsUrl) return

    const requestId = ++this.upsellRequestId
    const cartUrl = slot.dataset.cartUrl || '/cart.js'

    fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then(async (cart) => {
        if (requestId !== this.upsellRequestId) return

        const seen = new Set((cart.items || []).map((item) => String(item.product_id)))
        const cards = []
        const items = cart.items || []

        if (items.length) {
          const productId = items[0].product_id
          let html = await this.fetchRecommendations(slot, productId, 'complementary')
          if (requestId !== this.upsellRequestId) return
          this.collectUpsellCards(html, seen, cards)

          if (!cards.length) {
            html = await this.fetchRecommendations(slot, productId, 'related')
            if (requestId !== this.upsellRequestId) return
            this.collectUpsellCards(html, seen, cards)
          }
        } else {
          for (const productId of readViewedProducts()) {
            if (cards.length >= 7) break
            const html = await this.fetchRecommendations(slot, productId, 'related')
            if (requestId !== this.upsellRequestId) return
            this.collectUpsellCards(html, seen, cards)
          }
        }

        if (!cards.length && slot.dataset.fallbackUrl) {
          const html = await fetch(slot.dataset.fallbackUrl).then((response) => response.text())
          if (requestId !== this.upsellRequestId) return
          this.collectUpsellCards(html, seen, cards)
        }

        if (requestId !== this.upsellRequestId) return
        this.renderUpsell(slot, cards)
      })
      .catch(() => {
        if (requestId !== this.upsellRequestId) return
        this.renderUpsell(slot, [])
      })
  }

  close() {
    // Body
    document.documentElement.classList.remove('overflow-hidden')
    document.body.classList.remove('drawer-cart-is-open')

    // Container
    this.container.classList.add('invisible')
    this.container.classList.add('pointer-events-none')

    // Overlay
    this.overlay.classList.remove('opacity-60')
    this.overlay.classList.add('opacity-0')
    this.overlay.classList.add('delay-200')

    // Contents
    this.contents.classList.remove('right-0')
    this.contents.classList.add('-right-96')
  }

  renderContents(parsedState) {
    // TODO: Empty state should transition smoothly between empty state and non-empty state
    // this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    //   this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // TODO: Verify if this is working properly
    this.init()
    setTimeout(() => {
      this.open()
    },4)
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#cart-drawer-container',
      },
      {
        id: 'cart-button',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

}

customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-button',
        section: 'cart-button',
        selector: '.count',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);